import React from 'react'
import Text from './NewText'
import Link from '@/components/Common/Link'
type CollectionItem = {
  title?: string
  cta?: string
}

const CollectionItem = ({ title, cta }: CollectionItem) => {
  return (
    <Link
      href={cta ?? ''}
      className="bg-brand-tertiary-blue text-brand-blue-dark rounded-xl px-2 py-1"
    >
      <Text appearance="caption">{title}</Text>
    </Link>
  )
}

const LinkedCollection = ({
  linked_collections,
}: {
  linked_collections: CollectionItem[]
}) => {
  return (
    <div className="no-scrollbar my-2.5 flex gap-3 overflow-x-auto">
      {linked_collections.map(collectionItem => {
        return <CollectionItem {...collectionItem} key={collectionItem.title} />
      })}
    </div>
  )
}

export default LinkedCollection
